// ЛОГИСТИЧЕН МОДУЛ: CHECKOUT ТРАНСФЕР (АВТОМАТИЧЕН РАДАР И МАРКЕР)
document.addEventListener("DOMContentLoaded", function() {
  const checkoutBtn = document.getElementById("checkout");
  const modal = document.getElementById("magooShippingModal");
  const closeModal = document.getElementById("magooCloseModal");
  const step1 = document.getElementById("magooStep1");
  const step2 = document.getElementById("magooStep2");
  const submitBtn = document.getElementById("magooSubmitBtn");
  
  const firstNameInput = document.getElementById("magoo_first_name");
  const lastNameInput = document.getElementById("magoo_last_name");
  const phoneInput = document.getElementById("magoo_phone");
  const cityInput = document.getElementById("magoo_city");
  const zipInput = document.getElementById("magoo_zip_code");
  const visualZipInput = document.getElementById("magoo_addr_zip_visual");
  const officeInput = document.getElementById("magoo_selected_office_text");
  const addressInput = document.getElementById("magoo_addr_full");
  
  if (!checkoutBtn || !modal) return;
  
  document.body.insertBefore(modal, document.body.firstChild);

  window.magooCurrentMethod = ""; 

  // Централна функция за активиране на логистичния прозорец
  function openMagooModal() {
    step2.style.display = "none";
    step1.style.display = "block";
    modal.style.display = "flex";
  }

  // СЛУШАТЕЛ 1: Основният бутон в количката
  checkoutBtn.addEventListener("click", function(e) {
    e.preventDefault();
    openMagooModal();
  });

  // СОФТУЕРЕН РАДАР: Проверяваме дали клиентът идва от страничното меню с маркер за отваряне
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('openModal') === 'true') {
    // Изчистваме параметъра от адресната лента, за да не се отваря пак при обикновен рефреш
    const cleanUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
    window.history.replaceState({ path: cleanUrl }, '', cleanUrl);
    
    // Изстрелваме модала автоматично на екрана!
    openMagooModal();
  }

  if (closeModal) {
    closeModal.addEventListener("click", function() { modal.style.display = "none"; });
  }

  // Избор на Еконт офис
  document.getElementById("magooChooseEcont").addEventListener("click", function() {
    window.magooCurrentMethod = "Еконт";
    document.getElementById("selectedMethodName").innerText = "Еконт Офис";
    cityInput.readOnly = true;
    cityInput.style.backgroundColor = "#f4f6f9";
    step1.style.display = "none";
    step2.style.display = "block";
    document.getElementById("magooAddressGroup").style.display = "none";
    document.getElementById("magooOfficeSelectionGroup").style.display = "block";
    document.getElementById("magooEcontWrapper").style.display = "block";
    document.getElementById("magooSpeedyWrapper").style.display = "none";
    // Заковаваме 9999 за офисите
    officeInput.value = ""; cityInput.value = ""; zipInput.value = "9999";
    submitBtn.disabled = true;
  });

  // Избор на Спиди офис
  document.getElementById("magooChooseSpeedy").addEventListener("click", function() {
    window.magooCurrentMethod = "Спиди";
    document.getElementById("selectedMethodName").innerText = "Спиди Офис";
    cityInput.readOnly = true;
    cityInput.style.backgroundColor = "#f4f6f9";
    step1.style.display = "none";
    step2.style.display = "block";
    document.getElementById("magooAddressGroup").style.display = "none";
    document.getElementById("magooOfficeSelectionGroup").style.display = "block";
    document.getElementById("magooEcontWrapper").style.display = "none";
    document.getElementById("magooSpeedyWrapper").style.display = "block";
    // Заковаваме 9999 за офисите
    officeInput.value = ""; cityInput.value = ""; zipInput.value = "9999";
    submitBtn.disabled = true;
  });

  // Избор на Личен Адрес
  document.getElementById("magooChooseAddress").addEventListener("click", function() {
    window.magooCurrentMethod = "Адрес";
    document.getElementById("selectedMethodName").innerText = "Личен Адрес";
    cityInput.readOnly = false;
    cityInput.style.backgroundColor = "#fff";
    step1.style.display = "none";
    step2.style.display = "block";
    document.getElementById("magooOfficeSelectionGroup").style.display = "none";
    document.getElementById("magooAddressGroup").style.display = "block";
    officeInput.value = ""; cityInput.value = ""; visualZipInput.value = "1000";
    submitBtn.disabled = false;
  });

  // Генериране на Пермалинк
  submitBtn.addEventListener("click", function() {
    const fName = firstNameInput.value.trim();
    const lName = lastNameInput.value.trim();
    const phone = phoneInput.value.trim();
    const city = cityInput.value.trim();
    
    if (!fName || !lName || !phone || !city) { alert("Моля, попълнете всички полета!"); return; }

    let finalLocationText = (window.magooCurrentMethod === "Адрес") ? addressInput.value.trim() : officeInput.value.trim();
    if (!finalLocationText) { alert("Моля, изберете адрес или офис от картата!"); return; }

    submitBtn.disabled = true;
    submitBtn.innerText = "Обработка...";

    fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      if (!cart.items || cart.items.length === 0) { submitBtn.disabled = false; return; }

      let pathSegments = cart.items.map(item => `${item.variant_id}:${item.quantity}`).join(',');
      
      // Набиваме кодовете спрямо метода
      if (window.magooCurrentMethod === "Адрес") {
        let enteredZip = visualZipInput.value.trim();
        // Ако клиентът въведе 9999 за личен адрес, го коригираме на 1000, за да не извика офис тарифата
        zipInput.value = (enteredZip === "9999" || !enteredZip) ? "1000" : enteredZip;
      } else {
        // Офисите твърдо отиват на маркер 9999
        zipInput.value = "9999";
      }

      let permalinkUrl = `/cart/${pathSegments}?` +
        `checkout[shipping_address][first_name]=` + encodeURIComponent(fName) +
        `&checkout[shipping_address][last_name]=` + encodeURIComponent(lName) +
        `&checkout[shipping_address][phone]=` + encodeURIComponent(phone) +
        `&checkout[shipping_address][city]=` + encodeURIComponent(city) +
        `&checkout[shipping_address][zip]=` + encodeURIComponent(zipInput.value) +
        `&checkout[shipping_address][address1]=` + encodeURIComponent(finalLocationText) +
        `&checkout[shipping_address][country]=BG`;

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: {
            'Име': fName + " " + lName,
            'Телефон': phone,
            'Град': city,
            'Пощенски код': zipInput.value,
            'Метод': window.magooCurrentMethod,
            'Адрес/Офис': finalLocationText
          }
        })
      }).then(() => {
        window.location.href = permalinkUrl;
      });
    }).catch(err => {
      console.error(err);
      submitBtn.disabled = false;
      submitBtn.innerText = "Потвърди поръчката";
    });
  });
});